<div
  (click)="openChat($event)"
  (keydown.enter)="openChat($event)"
  (mouseenter)="onDiscoverCardMouseEnter()"
  (mouseleave)="onDiscoverCardMouseLeave()"
  (touchstart)="onDiscoverCardTouchStart()"
  class="discover-card relative"
  tabindex="-1"
>
  <div class="discover-card_media">
    <div class="image_wrapper">
      <ng-container *ngIf="isVideo(); else imageOrFallback">
        <stxt-video
          [src]="discoverItem.video"
          [videoId]="'discover-' + discoverItem.id"
          [mediaUsage]="EImageUsage.Discover"
          [muted]="true"
          [loop]="true"
          [autoplay]="false"
          [controls]="false"
          (videoEvent)="onVideoEvent($event)"
          class="primary-video"
        ></stxt-video>
      </ng-container>

      <ng-template #imageOrFallback>
        <ng-container *ngIf="isImage(); else fallbackImage">
          <stxt-image
            [src]="discoverItem.image"
            [alt]="discoverItem.name"
            [mediaUsage]="EImageUsage.Discover"
            class="primary-image"
          ></stxt-image>
        </ng-container>
      </ng-template>
    </div>
    <div class="additional_space"></div>
  </div>
  <div class="discover-card_nav absolute" [ngClass]="{ 'coming-soon': !discoverItem?.ready }">
    <ng-container *ngIf="discoverItem?.ready">
      <ng-container *ngTemplateOutlet="activeCreators"></ng-container>
    </ng-container>
  </div>
  <div class="discover-card_body absolute">
    <div class="discover-card_info">
      <div class="flex discover-card_head">
        <div class="discover-card_name relative">
          {{ truncate(discoverItem.name, 15) }}
          <span class="discover-card_ai absolute">
            <stxt-svg-icon class="verify-svg" [iconConfig]="verifySvg"></stxt-svg-icon>
          </span>
        </div>
      </div>
      <div class="discover-card_badge">
        <stxt-discover-card-badge
          *ngIf="getCardState()"
          [state]="getCardState()"
        ></stxt-discover-card-badge>
        <div *ngIf="discoverItem?.ready" class="discover-card_additional-info flex items-center">
          <div class="discover-card_additional-info__sfw flex">
            <p>
              {{ discoverItem?.not_safe_for_work ? '🔥 NSFW' : '😇 SFW' }}
            </p>
          </div>
          <span class="discover-card_divider">•</span>
          <div class="discover-card_additional-info__content flex">
            <div class="discover-card_additional-info__item flex">
              <p>
                <span class="discover-card_emoji">👤</span>
                {{ discoverItem.followers | numberCount }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="discover-card_description__wrapper">
        <p class="discover-card_description__text">{{ discoverItem.description }}</p>
        <stxt-play-voice-button
          *ngIf="discoverItem?.voice_preview?.length"
          #previewVoice
          [audio]="discoverItem.voice_preview"
          [audioId]="discoverItem.name"
          [usageCase]="EPlayButtonUsage.DiscoverCard"
          (voicePlaying)="trackVoicePlaying($event)"
        ></stxt-play-voice-button>
      </div>
    </div>
  </div>
</div>

<ng-template #fallbackImage>
  <div class="primary-image image-fallback"></div>
</ng-template>

<ng-template #activeCreators>
  <div class="discover-card_coming-soon">
    <div class="coming-soon_svg__wrapper relative">
      <stxt-svg-icon
        class="coming-soon_svg clock-svg_outlined"
        [iconConfig]="chatSvg"
        [disabled]="isChatLoading"
        (click)="openChat($event)"
        (keydown.enter)="openChat($event)"
        tabindex="-1"
      ></stxt-svg-icon>
      <stxt-svg-icon
        class="coming-soon_svg clock-svg_hovered"
        [iconConfig]="chatFilledSvg"
        [disabled]="isChatLoading"
        (click)="openChat($event)"
        (keydown.enter)="openChat($event)"
        tabindex="-1"
      ></stxt-svg-icon>
    </div>
    <p>Chat</p>
  </div>
</ng-template>

<ng-template #comingSoonCreators>
  <div class="discover-card_coming-soon">
    <div class="coming-soon_svg__wrapper relative">
      <stxt-svg-icon
        class="coming-soon_svg clock-svg_outlined"
        [iconConfig]="clockSvg"
      ></stxt-svg-icon>
      <stxt-svg-icon
        class="coming-soon_svg clock-svg_hovered"
        [iconConfig]="clockFilledSvg"
      ></stxt-svg-icon>
    </div>
    <p>Notify me</p>
  </div>
</ng-template>
